'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { FETCHED_SETTINGS } from '../actions/ActionTypes';
import { receiveSettings, requestedSettingsFailed, requestSettings } from '../actions/SettingsActions';
export default ((action$, _, {
  SettingsClient
}) => action$.ofType(FETCHED_SETTINGS).pipe(mergeMap(() => SettingsClient.fetch().pipe(map(receiveSettings), catchError(error => of(requestedSettingsFailed(error))), startWith(requestSettings())))));